import request from '@/utils/request-ecm'

/**
 * 云端 MEC Token
 * @returns {*}
 */
export function cloudMecToken(jingzhiLoginToken) {
  return request({
    url: '/auth/guest',
    method: 'get',
    params: { token: jingzhiLoginToken }
  })
}
